import { Injectable } from '@angular/core';

import { SummaryService } from './summary.service';
import type {
    TChartData, TSummaryCampaignDailyValues, TSummaryCustomerDailyValues,
    TSummaryTicketDailyValues, TSummaryTripDailyValues, TSummaryCampaignDoc,
    TSummaryCustomerDoc, TSummaryTicketDoc, TSummaryTripDoc
} from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class DashboardService {
    private colors = [
        // {'name': 'orange', 'rgba': 'rgba(255, 204, 102, 1.0)'},
        // {'name': 'purple', 'rgba': 'rgba(204, 102, 255, 1.0)'},
        // {'name': 'brown',  'rgba': 'rgba(204, 153, 102, 1.0)'},
        { 'name': 'green', 'rgba': 'rgba(153, 255, 102, 1.0)' },
        { 'name': 'yellow', 'rgba': 'rgba(255, 255, 102, 1.0)' },
        { 'name': 'blue', 'rgba': 'rgba(102, 204, 255, 1.0)' },
        { 'name': 'pink', 'rgba': 'rgba(255, 153, 153, 1.0)' }
    ];

    constructor(private summaryService: SummaryService) {
    }

    public getNullable(): TChartData {
        const NullChartData = {
            dailyValues: [0],
            runningTotalValues: [0],
            labels: [''],
            backgroundColors: [0],
            borderColors: [0],
        };
        return NullChartData;
    }

    /*
    From old
    public async getTicketsChartData(): Promise<TChartData> {
        let ticketDailyValues: TSummaryTicketDailyValues[] = [];

        const doc = await this.summaryService.getByUid('ticketsSummary') as TSummaryTicketDoc;
        if (doc) {
            ticketDailyValues = doc.dailyValues;
        }

        const chartData = this.buildChartData(ticketDailyValues, 'green');
        return chartData;
    }

    public async getTripsChartData(): Promise<TChartData> {
        let tripDailyValues: TSummaryTripDailyValues[] = [];

        const doc = await this.summaryService.getByUid('tripsSummary') as TSummaryTripDoc;
        if (doc) {
            tripDailyValues = doc.dailyValues;
        }

        const chartData = this.buildChartData(tripDailyValues, 'yellow');
        return chartData;
    }
    */
    public async getTicketsChartData(): Promise<TChartData> {
        let ticketDailyValues: TSummaryTicketDailyValues[] = [];

        const doc = await this.summaryService.getByUid('ticketsSummary') as TSummaryTicketDoc;
        if (doc) {
            ticketDailyValues = doc.dailyValues;
        }

        const chartData = this.buildChartData(ticketDailyValues, 'green');
        return chartData;
    }

    public async getTripsChartData(): Promise<TChartData> {
        let tripDailyValues: TSummaryTripDailyValues[] = [];

        const doc = await this.summaryService.getByUid('tripsSummary') as TSummaryTripDoc;
        if (doc) {
            tripDailyValues = doc.dailyValues;
        }

        const chartData = this.buildChartData(tripDailyValues, 'yellow');
        return chartData;
    }
    // public async getTripsChartData(): Promise<TChartData> {
    //     const doc = await this.summaryService.getByUid('tripsSummary');

    //     const chartData = this.buildChartData(doc?.dailyValues, 'yellow');
    //     return chartData;
    // }

    public async getCustomersChartData(): Promise<TChartData> {
        let customerDailyValues: TSummaryCustomerDailyValues[] = [];

        const doc = await this.summaryService.getByUid('customersSummary') as TSummaryCustomerDoc;
        if (doc) {
            customerDailyValues = doc.dailyValues;
        }

        const chartData = this.buildChartData(customerDailyValues, 'blue');
        return chartData;
    }
    // public async getCustomersChartData(): Promise<TChartData> {
    //     const doc = await this.summaryService.getByUid('customersSummary');

    //     const chartData = this.buildChartData(doc?.dailyValues, 'blue');
    //     return chartData;
    // }

    public async getCampaignsChartData(): Promise<TChartData> {
        let campaignDailyValues: TSummaryCampaignDailyValues[] = [];

        const item = await this.summaryService.getByUid('campaignsSummary');
        const doc = item as TSummaryCampaignDoc;
        if (doc) {
            campaignDailyValues = doc.dailyValues;
        }

        const chartData = this.buildChartData(campaignDailyValues, 'pink');
        return chartData;
    }
    // public async getCampaignsChartData(): Promise<TChartData> {
    //     const doc = await this.summaryService.getByUid('campaignsSummary');

    //     const chartData = this.buildChartData(doc?.dailyValues, 'pink');
    //     return chartData;
    // }

    // public getTripsPerDay(): Promise<any> {
    //     const endingDate = this.dateService.now();

    //     const promise = new Promise(async (resolve, reject) => {
    //         const profile = await this.getAccountProfile();
    //         const signupDate = profile.signupDate;

    //         // Get all the trips that were made between the signup date and today.
    //         const allTrips: TTrip[] = await this.tripsService.getByDateRange(signupDate, endingDate);
    //         resolve(allTrips);
    //     });
    //     return promise;
    // }

    public async buildChartData(dailyValues: any[], colorName: string): Promise<TChartData> {
        let runningTotal = 0;
        const chartData: TChartData = {
            'dailyValues': [],
            'runningTotalValues': [],
            'labels': [],
            'backgroundColors': [],
            'borderColors': []
        };

        if (!dailyValues) {
            // return this.nullValues;
            return this.getNullable();
        }

        // const dailyValues = doc.dailyValues;
        dailyValues.forEach((daily) => {
            const count = daily.count;
            const date = daily.date;

            // Labels is a collection of the dates
            chartData.labels.push(date);

            //
            chartData.dailyValues.push(count);

            // Compute running total
            runningTotal += count;
            chartData.runningTotalValues.push(runningTotal);

            // Background and border colors
            // Alternating colors
            // this.colorIdx = (this.colorIdx >= this.colors.length - 1 ? 0 : this.colorIdx + 1);
            // backgroundColors.push(this.colors[this.colorIdx].rgba);

            // Use the color that was passed in.
            let color = this.colors.find((kolor) => kolor.name === colorName);
            if (!color) {
                color = this.colors[0];
            }
            chartData.backgroundColors.push(color.rgba);
            chartData.borderColors.push('rgba(153, 153, 153, 1.0');
        });

        return chartData;
    }
}
